import type { Validator } from '../Validator'
import { validateCompleteError, validateCompleteSuccess } from '../Validator'

export const compareValidator = (
    options: Validator.options & { operation: 'equal' | 'notEqual'; to: any }
): Validator.validatorSingle<any, unknown> => ({
    isAsync: false,
    validate: value => {
        const areStringsEqual = (v: string, toCompare: string): boolean => v.toUpperCase() === toCompare.toUpperCase()

        switch (options.operation) {
            case 'equal':
                return (typeof value === 'string' &&
                    typeof options.to === 'string' &&
                    !areStringsEqual(value, options.to)) ||
                    value !== options.to
                    ? validateCompleteError(options, `Il valore deve essere uguale a ${options.to}`)
                    : validateCompleteSuccess()

            case 'notEqual':
                return (typeof value === 'string' &&
                    typeof options.to === 'string' &&
                    areStringsEqual(value, options.to)) ||
                    value === options.to
                    ? validateCompleteError(options, `Il valore deve essere diverso da ${options.to}`)
                    : validateCompleteSuccess()
        }
    },
})
